import { extendServiceContainer } from '@iotize/tap';
import { CloudService } from './service';

declare module '@iotize/tap/lib/service-container' {
  interface ServiceContainer {
    cloud: CloudService;
  }
}

export const _TAP_SERVICE_EXTENSION_CLOUD_ = extendServiceContainer(
  'cloud',
  CloudService,
);
